export enum Blocks {
    TEXT = "text",
    VIDEO = "video-embed",
    CHAT = "chat-bot",
    HIGHLIGHTS = "content-highlights",

}
